import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { OneIdEnv, Entitlements, Flags, AuthTypes } from 'enums';
import * as oneId from 'lib/oneId';
import { streamHasDTCPackage } from 'lib/auth';
import { checkESPNPlusAuthentication } from 'lib/auth/shallowCheckAuthentication';
import { addQueryToUrl } from 'lib/format';
import { clearGuest, launchLogin, launchReauth, checkOneIDAuthentication } from 'common/actions/oneIdActions';
import { getAiring } from 'common/page/actions';
import { oneIdEnvSelector } from 'common/selectors/appSelector';
import oneIdSelector, { oneIdLoggedInSelector, oneIdEntitlementsSelector } from 'common/selectors/oneIdSelector';
import { userAuthSelector } from 'common/selectors/authenticationSelectors';

const { OneIdJs } = oneId;

export class AccountSelectorComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            purchaseFlow: false,
            mode: AccountSelectorComponent.MODE.UNKNOWN
        };
        this.getGuest = this.getGuest.bind(this);
        this.clearGuest = this.clearGuest.bind(this);
        this.onTVEClick = this.onTVEClick.bind(this);
        this.onPurchaseClick = this.onPurchaseClick.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.processRedirect = this.processRedirect.bind(this);
        this.processRedirectBySkip = this.processRedirectBySkip.bind(this);
        this.navigateToESPNPlus = this.navigateToESPNPlus.bind(this);
    }

    async componentDidMount() {
        const { dispatch, location: { query: { id } } } = this.props;
        oneId.on('login', this.getGuest);
        oneId.on('logout', this.clearGuest);
        const { isLoggedIn } = await dispatch(checkOneIDAuthentication());
        if (id) {
            try {
                const airing = await dispatch(getAiring({ id }));
                this.setContent(airing);
            } catch (err) {
                console.error(err);
            }

            if (!isLoggedIn) {
                this.onLogin();
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const { packages } = this.state;
        const notEntitledForContent = this.isNotEntitledForContent();
        const nextNotEntitledForContent = this.isNotEntitledForContent(nextProps);
        if (packages && notEntitledForContent && !nextNotEntitledForContent) {
            this.processRedirect();
        }
    }

    componentDidUpdate(prevProps, { packages: prevPackages }) {
        const { packages } = this.state;
        if (!prevPackages && packages) {
            const notEntitledForContent = this.isNotEntitledForContent();
            if (!notEntitledForContent) {
                this.processRedirect();
            }
        }
    }

    componentWillUnmount() {
        oneId.off('login', this.getGuest);
        oneId.off('logout', this.clearGuest);
    }

    onTVEClick() {
        const { location: { query: { redirectUrl } = {} } } = this.props;
        if (redirectUrl) {
            const win = window.parent !== window.self ? window.parent : window;
            win.location.href = `${redirectUrl}${redirectUrl.indexOf('?') > -1 ? '&' : '?'}auth=tve`;
        }
    }

    onLogin() {
        const { dispatch, isLoggedIn } = this.props;
        if (isLoggedIn) {
            dispatch(launchReauth());
            return;
        }
        dispatch(launchLogin());
    }

    onPurchaseClick() { // eslint-disable-line
        alert('Purchase flow'); // eslint-disable-line no-alert
    }

    onCancelClick() {
        this.navigateToESPNPlus();
    }

    setContent(airing = {}) {
        const packages = airing.packages && airing.packages.map(({ name }) => name);
        if (!packages) {
            return;
        }
        console.log('ariging', airing); // eslint-disable-line no-console
        this.setState({ packages });
    }

    getMode() {
        let mode = AccountSelectorComponent.MODE.UNKNOWN;
        const { packages } = this.state;
        const { location: { query: { mode: modeArg, matchup: isMatchup } }, entitlements } = this.props;
        if (modeArg !== undefined) { // override
            mode = parseInt(modeArg, 10);
        } else if (packages) {
            const hasMLB = streamHasDTCPackage({ packages }, Entitlements.ESPN_PLUS_MLB);
            const isVertical = hasMLB || streamHasDTCPackage({ packages }, Entitlements.ESPN_PLUS_NHL);
            const hasESPNPlusBase = entitlements && entitlements.indexOf(Entitlements.ESPN_PLUS) > -1;

            if (!isVertical) {
                if (isMatchup) { // TODO: how do we know from graphql response that the steream is matchup?
                    mode = AccountSelectorComponent.MODE.PURCHASE_BASE_MATCHUP;
                } else {
                    mode = AccountSelectorComponent.MODE.PURCHASE_BASE;
                }
            } else if (!hasMLB) {
                mode = AccountSelectorComponent.MODE.PURCHASE_NHL;
            } else if (hasESPNPlusBase) {
                mode = AccountSelectorComponent.MODE.PURCHASE_MLB_ADDON;
            } else {
                mode = AccountSelectorComponent.MODE.PURCHASE_MLB_BUNDLE;
            }
        }

        return mode;
    }

    getGuest() {
        this.props.dispatch(checkOneIDAuthentication());
    }

    clearGuest() {
        return this.props.dispatch(clearGuest());
    }

    processRedirect(isSkip = false) {
        const { location: { query: { redirectUrl } = {} } } = this.props;
        if (redirectUrl) {
            const win = window.parent !== window.self ? window.parent : window;
            win.location.href = `${redirectUrl}${isSkip ? '&bypassAuth=true' : ''}`;
        }
    }

    processRedirectBySkip() {
        // this.processRedirect(true);
        this.navigateToESPNPlus();
    }

    navigateToESPNPlus() {
        const { location: { query = {} } } = this.props;
        const newQuery = {};
        if (query[Flags.ONEID_ENV] === OneIdEnv.STAGING) {
            newQuery.debug = true;
            newQuery.disneyid = 'stg';
        }
        const win = window.parent !== window.self ? window.parent : window;
        win.location.href = addQueryToUrl(`${window.location.origin}/watch/espnplus`, newQuery);
    }

    isNotEntitledForContent(props = this.props) {
        const { packages } = this.state;
        const {
            userAuth
        } = props;

        const authTypes = [AuthTypes.BAM];
        if (!packages) {
            return true;
        }
        const ESPNPlusAuthentication = checkESPNPlusAuthentication({ authTypes, packages }, userAuth);

        return !ESPNPlusAuthentication;
    }

    render() {
        const {
            oneIdEnv,
            isLoggedIn,
            oneIdData,
            entitlements
        } = this.props;

        const mode = this.getMode();
        const notEntitledForContent = this.isNotEntitledForContent();
        const modeKnown = mode !== AccountSelectorComponent.MODE.UNKNOWN;
        const title = AccountSelectorComponent.TITLE[mode];
        const label = AccountSelectorComponent.LABEL[mode];
        const entitlementsInfo = entitlements && entitlements.length ? `(${entitlements.join(',')})` : '(No entitlements)';
        const loginLabel = isLoggedIn ? (
            <span className="login-label">
                Hi, <a className="login-btn" onClick={this.onLogin}>{oneIdData.profile.firstName}</a>{entitlementsInfo}
            </span>
        ) : (
            <span className="login-label"><a className="login-btn" onClick={this.onLogin}>Log In</a></span>
        );

        return (
            <div>
                <Helmet
                    meta={[
                        { name: 'robots', content: 'noindex, nofollow' }
                    ]}
                    script={[{
                        src: OneIdJs[oneIdEnv]
                    }]}
                    style={[{
                        cssText: `
                            body {
                                background: url(https://secure.espncdn.com/redesign/assets/img/dtc/auth-bg-1280x728.png) no-repeat;
                                background-attachment: fixed;
                                background-size: cover;
                                min-height: 100vh;
                                margin: 0;
                                color: #fff;
                                font-family: SFProText, sans-serif;
                                text-align: center;
                            }

                            .account-selector {
                                margin: 0 auto;
                                padding: 0 0 0 50px;
                            }
                            .selection-wrap {
                                margin: 0 auto;
                            }
                            .account-selector .title {
                                font-size: 48px;
                            }
                            .account-selector button {
                                display: inline-block;
                                padding: 10px 20px;
                                border: none;
                                font-size: 16px;
                                color: #fff;
                                text-align: center;
                                text-shadow: 0 1px 0 rgba(198, 132, 6, 0.5);
                                width: 250px;
                                height: 48px;
                                border-radius: 100px;
                                background-image: linear-gradient(to top, #cc8804, #eba114 46%, #f9b300);
                                margin: 0 5px 20px 5px;
                                cursor: pointer;
                            }
                            .account-selector button.tve-btn {
                                display: block;
                                margin: 0 auto 10px auto;
                                background-image: linear-gradient(to bottom, #0f73d7, #0066cc 47%, #045cb4);
                            }
                            .account-selector button.eplus-btn {
                                display: block;
                                margin: 0 auto 10px auto;
                            }
                            .account-selector a {
                                color: #f9b300;
                                cursor: pointer;
                                margin-right: 20px;
                            }
                            .account-selector .head-section {
                                height: 50px;
                                padding-top: 28px;
                            }

                            .account-selector .head-section .logo {
                                float: left;
                                width: 100px;
                                height: auto;
                            }
                            .account-selector .head-section .login-label {
                                float: right;
                                margin-right: 20px;
                            }
                            .account-selector .head-section .login-btn {
                                margin-right: 0;
                            }
                            .account-selector .head-section .login-btn:hover {
                                text-decoration: underline;
                            }
                        `
                    }]}
                />
                {modeKnown && (
                    <div className="account-selector">
                        <section className="head-section">
                            <a onClick={this.navigateToESPNPlus}>
                                <img
                                    className="logo"
                                    src="https://secure.espncdn.com/espn360/images/affiliates/svg/ESPN_PLUS/ESPN-PLUS_CLR-NEG.svg"
                                    alt="ESPN+"
                                />
                            </a>
                            {loginLabel}
                        </section>
                        <h1 className="title">{title}</h1>
                        <section className="selection-wrap">
                            {mode === AccountSelectorComponent.MODE.ACCOUNT_SELECTOR && (
                                <div>
                                    <button className="tve-btn" onClick={this.onTVEClick}>Log In with TV Provider</button>
                                    <button className="eplus-btn" onClick={this.onLogin}>Log In to ESPN Account</button>
                                    <button className="eplus-btn" onClick={this.onPurchaseClick}>{label}</button>
                                </div>
                            )}
                            {notEntitledForContent && (
                                <div>
                                    <button onClick={this.onPurchaseClick}>{label}</button>
                                    <a
                                        onClick={this.processRedirectBySkip}
                                        style={{ marginLeft: 20 }}
                                    >
                                        Skip Purchase
                                    </a>
                                </div>
                            )}

                        </section>
                    </div>
                )}
            </div>
        );
    }
}

AccountSelectorComponent.propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    oneIdEnv: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    oneIdData: PropTypes.object,
    entitlements: PropTypes.array
};

AccountSelectorComponent.MODE = {
    UNKNOWN: -1,
    ACCOUNT_SELECTOR: 0,
    PURCHASE_NHL: 1,
    PURCHASE_MLB_BUNDLE: 2,
    PURCHASE_MLB_ADDON: 3,
    PURCHASE_BASE: 4,
    PURCHASE_BASE_MATCHUP: 5
};

AccountSelectorComponent.TITLE = {
    [AccountSelectorComponent.MODE.UNKNOWN]: '',
    [AccountSelectorComponent.MODE.ACCOUNT_SELECTOR]: 'Account Selector',
    [AccountSelectorComponent.MODE.PURCHASE_NHL]: 'Add NHL.TV to ESPN+',
    [AccountSelectorComponent.MODE.PURCHASE_MLB_BUNDLE]: 'MLB.TV & ESPN+',
    [AccountSelectorComponent.MODE.PURCHASE_MLB_ADDON]: 'Add MLB.TV to ESPN+',
    [AccountSelectorComponent.MODE.PURCHASE_BASE]: 'More Sports. More Leagues.',
    [AccountSelectorComponent.MODE.PURCHASE_BASE_MATCHUP]: 'Matchup Paywall'
};

AccountSelectorComponent.LABEL = {
    [AccountSelectorComponent.MODE.UNKNOWN]: '',
    [AccountSelectorComponent.MODE.ACCOUNT_SELECTOR]: 'Start My 7 Day Trial',
    [AccountSelectorComponent.MODE.PURCHASE_NHL]: '$24.99/monthly',
    [AccountSelectorComponent.MODE.PURCHASE_MLB_BUNDLE]: '$29.98/monthly',
    [AccountSelectorComponent.MODE.PURCHASE_MLB_ADDON]: '$29.98/monthly',
    [AccountSelectorComponent.MODE.PURCHASE_BASE]: '$4.99/monthly',
    [AccountSelectorComponent.MODE.PURCHASE_BASE_MATCHUP]: 'Start My 7 Day Trial'
};

const mapStateToProps = (state) => {
    const oneIdState = oneIdSelector(state);
    return {
        oneIdEnv: oneIdEnvSelector(state),
        isLoggedIn: oneIdLoggedInSelector(state),
        entitlements: oneIdEntitlementsSelector(state),
        oneIdData: oneIdState && oneIdState.data,
        userAuth: userAuthSelector(state)
    };
};

export default connect(mapStateToProps)(AccountSelectorComponent);



// WEBPACK FOOTER //
// ./app/common/page/AccountSelector.js